// extracted by css-extract-rspack-plugin
export default {"dropdown":"WTflOyf3YFYIvhVR","mainNavItem":"G3S47WX6NcIsw0S2","active":"z6ncatf32Box3Ejd","subMenuItem":"W5Lx7FILU_xbTqoy","overlay":"M587XBOf1QMxeY1D"};